import { AccountItemEnum } from '../../../../../../../../../modules/mobile/modals/profile';

export default {
  title: 'Tili',
  items: {
    [AccountItemEnum.ManageAccount]: {
      title: 'Hallitse tiliä',
      description: 'Pidä tilisi ajan tasalla ja hallitse asetuksiasi.',
    },
    [AccountItemEnum.PaymentMethods]: {
      title: 'Maksutavat',
      description: 'Lisää, vaihda tai valitse haluamasi maksutapa.',
    },
    [AccountItemEnum.HelpAndFAQs]: {
      title: 'Ohjeet ja UKK',
    },
    [AccountItemEnum.Logout]: {
      title: 'Kirjaudu ulos',
    },
    [AccountItemEnum.Language]: {
      title: 'Kieli',
    },
  },
};
